export default {"src":"/uk/_next/static/media/fingerprint.34073008.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};